const homeRoute = 'inicial';

const servicesRoute = 'servicos';
const servicesAccessServiceRoute = 'acessar';
const servicesEnrollmentRoute = 'habilitacao-de-usuarios';
const servicesPersonalDataRoute = 'atualizacao-cadastral';

const servicoReembolso = 'reembolso-eletronico';
const serviceCategories = 'categorias';

const helpCenterRoute = 'central-de-ajuda';
const helpCenterCategoriaRoute = 'categoria';
const helpCenterFaqRoute = 'pergunta-frequente';

const consultaCoberturaRoute = 'consulta-cobertura';
const hospitalMedicalGuideRoute = 'guia-medico-hospitalar';
const hospitalMedicalGuideRouteDetails = 'prestador';

const contactUsRoute = 'fale-conosco';

const myAccountRoute = 'minha-conta';
const myAccountMyDataRoute = 'meus-dados';
const myAccountMyPlansRoute = 'meus-planos';
const myAccountMyServicesRoute = 'meus-servicos';
const myAccountMyTreatmentsRoute = 'meus-atendimentos';
const myAccountMyExaminationsRoute = 'meus-exames';
const myAccountMyBillsRoute = 'minhas-faturas';

const profileRoute = 'perfil';

const attendanceHistoryRoute = 'historico-de-protocolos';

const satisfactionSurveyRoute = 'pesquisa-de-satisfacao';
const satisfactionSurveyRouteHash = 'pesquisa-de-satisfacao/:hash';

const styleguideRoute = 'styleguide';

const pesquisaPrestadoresRota = 'pesquisa-prestadores';


const simuladorRota = 'simulador';

export const APP_ROUTES = {
  home: {
    route: homeRoute,
    url: `/${homeRoute}`
  },
  services: {
    route: servicesRoute,
    url: `/${servicesRoute}`,
    subChildren: {
      accessService: {
        route: servicesAccessServiceRoute,
        url: `/${servicesAccessServiceRoute}`,
        children: {
          enrollment: {
            route: servicesEnrollmentRoute,
            url: `/${servicesEnrollmentRoute}`
          },
          personalData: {
            route: servicesPersonalDataRoute,
            url: `/${servicesPersonalDataRoute}`
          },
          reembolso: {
            route: servicoReembolso,
            url: `/${servicoReembolso}`
          }
        }
      }, 
      categories: {
        route: serviceCategories,
        url: `/${serviceCategories}`
      }
    }
  },
  helpCenter: {
    route: helpCenterRoute,
    url: `/${helpCenterRoute}`,
    children: {
      categoria: {
        route: helpCenterCategoriaRoute,
        url: `/${helpCenterRoute}/${helpCenterCategoriaRoute}`
      },
      faq: {
        route: helpCenterFaqRoute,
        url: `/${helpCenterRoute}/${helpCenterFaqRoute}`
      }

    }
  },
  consultaCobertura: {
    route: consultaCoberturaRoute,
    url: `/${consultaCoberturaRoute}`
  },
  hospitalMedicalGuide: {
    route: hospitalMedicalGuideRoute,
    url: `/${hospitalMedicalGuideRoute}`,
    children: {
      details: {
        route: hospitalMedicalGuideRouteDetails,
        url: `/${hospitalMedicalGuideRoute}/${hospitalMedicalGuideRouteDetails}`
      }
    }
  },
  contactUs: {
    route: contactUsRoute,
    url: `/${contactUsRoute}`
  },
  myAccount: {
    route: myAccountRoute,
    url: `/${myAccountRoute}`,
    children: {
      myData: {
        route: myAccountMyDataRoute,
        url: `/${myAccountRoute}/${myAccountMyDataRoute}`
      },
      myPlans: {
        route: myAccountMyPlansRoute,
        url: `/${myAccountRoute}/${myAccountMyPlansRoute}`
      },
      myServices: {
        route: myAccountMyServicesRoute,
        url: `/${myAccountRoute}/${myAccountMyServicesRoute}`
      },
      myTreatments: {
        route: myAccountMyTreatmentsRoute,
        url: `/${myAccountRoute}/${myAccountMyTreatmentsRoute}`
      },
      myExaminations: {
        route: myAccountMyExaminationsRoute,
        url: `/${myAccountRoute}/${myAccountMyExaminationsRoute}`
      },
      myBills: {
        route: myAccountMyBillsRoute,
        url: `/${myAccountRoute}/${myAccountMyBillsRoute}`
      }
    }
  },
  profile: {
    route: profileRoute,
    url: `/${profileRoute}`
  },
  attendanceHistory: {
    route: attendanceHistoryRoute,
    url: `/${attendanceHistoryRoute}`
  },

  satisfactionSurvey: {
    route: satisfactionSurveyRoute,
    url: `/${satisfactionSurveyRoute}`
  },

  satisfactionSurveyHash: {
    route: satisfactionSurveyRouteHash,
    url: `/${satisfactionSurveyRouteHash}`
  },

  styleguide: {
    route: styleguideRoute,
    url: `/${styleguideRoute}`
  },

  pesquisaPrestadores: {
    route: pesquisaPrestadoresRota,
    url: `/${pesquisaPrestadoresRota}`
  },

  simulador: {
    route: simuladorRota,
    url: `/${simuladorRota}`
  }

};
